import { dispatch } from "@rematch/core";
import { getCountry, getCity, getArea } from "utils/interface";
import { CQ } from "utils/commonQuest";

export const region = {
  state: {},
  effects: {
    // 获取国家数据
    async getCountry(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getCountry);
      const data = await CQ(getCountry());
      if (!data || !data) {
        console.warn("未从接口获取到国家信息");
      }
      dispatch["share"].updateCountry(data);
    },
    // 获取城市数据
    async getCity(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getCity);
      const data = await CQ(getCity(payload));
      dispatch["share"].updateCity(data);
    },
    // 获取区域数据
    async getArea(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getArea);
      const data = await CQ(getArea());
      dispatch["share"].updateArea(data);
    }
  }
};
